import { render } from "./ToggleSwitchField.vue?vue&type=template&id=31997401"
import script from "./ToggleSwitchField.vue?vue&type=script&lang=js"
export * from "./ToggleSwitchField.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__